"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsProductionOrderStatusRectangle = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProductionOrderStatus = require("../../constants/ProductionOrderStatus");
var _StatusProductionOrderBatchColors = require("../../constants/StatusProductionOrderBatchColors");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsbatchStatusRectangle component
 * 
 * @param {object} status - Status of production order
 */

const DmsProductionOrderStatusRectangle = _ref => {
  let {
    status
  } = _ref;
  const statusColors = {
    [_ProductionOrderStatus.ProductionOrderStatus.PAUSED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.PAUSED,
    [_ProductionOrderStatus.ProductionOrderStatus.CREATED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.CREATED,
    [_ProductionOrderStatus.ProductionOrderStatus.PRODUCTION]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.PRODUCTION_AND_STARTED,
    [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_OK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.FINISHED_OK,
    [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_NOK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.FINISHED_NOK,
    [_ProductionOrderStatus.ProductionOrderStatus.SHIPPED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.SHIPPED,
    [_ProductionOrderStatus.ProductionOrderStatus.CANCELLED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.CANCELLED
  };
  const statusLabels = {
    [_ProductionOrderStatus.ProductionOrderStatus.PAUSED]: _reactIntlUniversal.default.get("Paused").d("Paused"),
    [_ProductionOrderStatus.ProductionOrderStatus.CREATED]: _reactIntlUniversal.default.get("Created").d("Created"),
    [_ProductionOrderStatus.ProductionOrderStatus.PRODUCTION]: _reactIntlUniversal.default.get("Production").d("Production"),
    [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_OK]: _reactIntlUniversal.default.get("FinishedOK").d("Finished OK"),
    [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_NOK]: _reactIntlUniversal.default.get("FinishedNOK").d("Finished NOK"),
    [_ProductionOrderStatus.ProductionOrderStatus.SHIPPED]: _reactIntlUniversal.default.get("Shipped").d("Shipped"),
    [_ProductionOrderStatus.ProductionOrderStatus.CANCELLED]: _reactIntlUniversal.default.get("Cancelled").d("Cancelled")
  };
  const letterColors = {
    [_ProductionOrderStatus.ProductionOrderStatus.PAUSED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.PAUSED_LETTER_COLOR,
    [_ProductionOrderStatus.ProductionOrderStatus.CREATED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_ProductionOrderStatus.ProductionOrderStatus.PRODUCTION]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_OK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_ProductionOrderStatus.ProductionOrderStatus.FINISHED_NOK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_ProductionOrderStatus.ProductionOrderStatus.SHIPPED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_ProductionOrderStatus.ProductionOrderStatus.CANCELLED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR
  };
  const backgroundColor = statusColors[status];
  const label = statusLabels[status];
  const letterColor = letterColors[status];
  return /*#__PURE__*/_react.default.createElement(_material.Chip, {
    label: label,
    sx: {
      backgroundColor,
      color: letterColor,
      fontWeight: 'bold',
      minWidth: '5vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  });
};
exports.DmsProductionOrderStatusRectangle = DmsProductionOrderStatusRectangle;
DmsProductionOrderStatusRectangle.propTypes = {
  status: _propTypes.default.oneOf(Object.values(_ProductionOrderStatus.ProductionOrderStatus)).isRequired
};